/**
 * Service provider not found.
 */
export class ProviderNotFoundWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('ProviderNotFound');

    this.httpCode = 404;
    this.statusCode = 'NOT_FOUND';
    this.applicationCode = 'PROVIDER_NOT_FOUND';
    this.name = 'ProviderNotFound';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'ProviderNotFound',
      applicationCode: 'PROVIDER_NOT_FOUND',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}
